import { css, keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { darken, saturate } from 'polished';
import { color } from '@lightspeed/cirrus-tokens/utils';

const animationDelay = '0.2s';
const lightBlue = darken(0.2, saturate(0.2, color('blue-100')));

const progressBarWidth = ({ progress }) => {
  let width;
  if (!progress) width = '0';
  if (progress === 'start') width = '90%';
  if (progress === 'complete') width = '100%';
  return css`
    width: ${width};
  `;
};
const loadingAnimation = keyframes`
  0% { width: 0; }
  60% { width: 85%; }
  100% { width: 90%; }
`;
const bgLoadingAnimation = keyframes`
  0% { background-position: 0 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
`;
const progressBarAnimation = ({ progress }) =>
  progress === 'start' &&
  css`
    animation: ${loadingAnimation} 10s ease-out, ${bgLoadingAnimation} 10s ease-in-out infinite;
  `;

export const PageProgressContainer = styled('div')`
  width: 100%;
  height: 3px;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  display: flex;
  position: sticky;
  top: ${() => (window.isGriffin() ? '0' : '54px')};
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  z-index: 3;
  transition: ${({ hidden }) =>
    hidden
      ? `visibility 0s ${animationDelay}, opacity 0.2s ease-out`
      : `visibility 0s, opacity ${animationDelay} 0.2s ease-in`};
`;

export const PageProgressBar = styled('div')`
  ${progressBarWidth};
  height: 3px;
  border-radius: 1px;
  background: linear-gradient(
    -45deg,
    ${color('blue')},
    ${lightBlue},
    ${color('blue')},
    ${lightBlue}
  );
  background-size: 400% 400%;
  position: absolute;
  left: 0;
  ${progressBarAnimation};
`;
